import { render, staticRenderFns } from "./switch-defaultValue-editor.vue?vue&type=template&id=7d64206c&scoped=true"
import script from "./switch-defaultValue-editor.vue?vue&type=script&lang=js"
export * from "./switch-defaultValue-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d64206c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d64206c')) {
      api.createRecord('7d64206c', component.options)
    } else {
      api.reload('7d64206c', component.options)
    }
    module.hot.accept("./switch-defaultValue-editor.vue?vue&type=template&id=7d64206c&scoped=true", function () {
      api.rerender('7d64206c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-switch/switch-defaultValue-editor.vue"
export default component.exports